export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1750_.ada99f61.jpg";